<div class="text-center">
    <!-- put a litle close button on top -->
    <button mat-icon-button (click)="this.dialogRef.close()" style="position: absolute; right: 0; top: 0;">
        <mat-icon>close</mat-icon>
    </button>
    <h6 class="m-0 pb-1" style="white-space: pre-wrap; line-height: 1.4;">{{ title }}</h6>
    <div mat-dialog-content>
        <mat-spinner [style.margin]="'auto'" [mode]="(this.progress??-1)===-1?'indeterminate':'determinate'"
        [value]="this.progress"
        ></mat-spinner>
    </div>
    <h4 class="m-0 pb-1" style="white-space: pre-wrap; line-height: 1.4;">{{ message }}</h4>
</div>
